/* global axios */
import ApiClient from '../ApiClient';

// API do painel "perguntar ao Capitao". O menu ✨ (sugerir/resumir/melhorar) usa o
// TasksAPI re-apontado (api/captain/tasks.js); aqui fica so o ask do painel lateral.
class CapitaoAPI extends ApiClient {
  constructor() {
    super('fandata/capitao', { accountScoped: true });
  }

  ask(conversationId, question) {
    return axios.post(`${this.url}/ask`, {
      conversation_display_id: conversationId,
      question,
    });
  }
}

export default new CapitaoAPI();
